import {
  SixDigitsCodeInput,
  SixDigitsCodeInputProps,
  SixDigitsCodeInputRef
} from '@emerald-ui/inputs'
import { Box } from '@mui/material'
import { forwardRef, useLayoutEffect, useRef } from 'react'

type OneTimeCodeInputProps = SixDigitsCodeInputProps & { label: string }

export default forwardRef<SixDigitsCodeInputRef, OneTimeCodeInputProps>(function OneTimeCodeInput(
  { label, ...props },
  ref
) {
  const container = useRef<HTMLDivElement>(null)
  useLayoutEffect(() => {
    // The library does not expose input props; keep native hints scoped to its inputs.
    container.current?.querySelectorAll('input').forEach((input, index) => {
      input.autocomplete = index === 0 ? 'one-time-code' : 'off'
      input.inputMode = 'numeric'
      input.pattern = '[0-9]*'
      input.name = index === 0 ? 'one-time-code' : `one-time-code-${index + 1}`
      input.setAttribute('aria-label', `${label} ${index + 1}`)
    })
  }, [label])

  return (
    <Box ref={container}>
      <SixDigitsCodeInput {...props} ref={ref} />
    </Box>
  )
})
